// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerInterestsHeader_block__kHcEM","team":"PlayerInterestsHeader_team__aq3Ni","stats":"PlayerInterestsHeader_stats__IjUp_"};